import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch } from "react-redux";
import Input from "../../FormElements/Input";
import Textarea from "../../FormElements/Textarea";
import { Button } from "react-bootstrap";
import { redirectUrl } from "../../../services/GlobalUrls";
import { urls } from "../../../services/Urls";
import request from "../../../services/Request";
import {
  submitDataOnRequest,
  getDataOnRequest,
  successToast,
  errorToast,
} from "../../../redux/actions/CommonActions";

const IncidentLog = (props) => {
  const [incidentLogData, setIncidentLogData] = useState({});
  const [isViewMode, setIsViewMode] = useState(false);
  const { userDetails, userProfileData } = props;
  const fetchedRef = useRef(false);

  const dispatch = useDispatch();

  // Fetch incident log data when in view mode
  useEffect(() => {
    if (fetchedRef.current) return;
    const viewMode = sessionStorage.getItem("incidentLogViewMode");
    const viewId = sessionStorage.getItem("incidentLogViewId");
    if (viewMode === "true" && viewId && userDetails && userDetails.users_access_token) {
      fetchedRef.current = true;
      sessionStorage.removeItem("incidentLogViewMode");
      sessionStorage.removeItem("incidentLogViewId");
      setIsViewMode(true);
      const fetchIncidentLog = async () => {
        try {
          const url =
            urls.GetIncidentLog +
            userDetails.users_access_token +
            "/" +
            viewId +
            "/";
          const response = await request({ url: url, method: "GET" });
          if (
            response &&
            response.data &&
            response.data.status === "success" &&
            response.data.data
          ) {
            const data = { ...response.data.data };
            if (data.incident_log_accident_incident_datetime) {
              const dt = data.incident_log_accident_incident_datetime;
              if (dt.includes(" ") && !dt.includes("T")) {
                data.incident_log_accident_incident_datetime = dt
                  .replace(" ", "T")
                  .substring(0, 16);
              }
            }
            setIncidentLogData(data);
          } else {
            errorToast("Incident log not found.");
          }
        } catch (e) {
          errorToast("Failed to load incident log.");
        }
      };
      fetchIncidentLog();
    }
  }, [userDetails]);

  // Logged In Username
  const loggedInUsername =
    ((userProfileData && userProfileData.users_firstname) ||
      (userDetails && userDetails.users_firstname) ||
      "") +
    " " +
    ((userProfileData && userProfileData.users_lastname) ||
      (userDetails && userDetails.users_lastname) ||
      "");

  const onChangeInputvalue = async (e) => {
    setIncidentLogData({
      ...incidentLogData,
      [e.target.name]: e.target.value,
    });
    let field = document.getElementById(e.target.name);
    let fieldMsg = document.getElementById(e.target.name + "_msg");
    if (fieldMsg) {
      fieldMsg.style.display = "none";
      fieldMsg.innerText = "";
    }
    if (field) {
      field.classList.remove("border-danger");
    }
  };

  const showFieldError = (name, message) => {
    let field = document.getElementById(name);
    let fieldMsg = document.getElementById(name + "_msg");
    if (field) {
      field.classList.add("border-danger");
    }
    if (fieldMsg) {
      fieldMsg.style.display = "block";
      fieldMsg.innerText = message;
    }
  };

  const getNowMax = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const hh = String(now.getHours()).padStart(2, "0");
    const min = String(now.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  };

  const focusFirstError = (fieldNames) => {
    for (let name of fieldNames) {
      let field = document.getElementById(name);
      if (field && field.classList.contains("border-danger")) {
        field.focus();
        break;
      }
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    let applyError = false;

    // Service User Name Start
    if (
      !incidentLogData.incident_log_service_user_name ||
      incidentLogData.incident_log_service_user_name.trim() == ""
    ) {
      showFieldError(
        "incident_log_service_user_name",
        "Please enter the service user name!",
      );
      applyError = true;
    }
    // Service User Name End

    // Location Start
    if (
      !incidentLogData.incident_log_accident_incident_location ||
      incidentLogData.incident_log_accident_incident_location.trim() == ""
    ) {
      showFieldError(
        "incident_log_accident_incident_location",
        "Please enter the location of accident/incident!",
      );
      applyError = true;
    }
    // Location End

    // Date & Time Start
    if (
      !incidentLogData.incident_log_accident_incident_datetime ||
      incidentLogData.incident_log_accident_incident_datetime.trim() == ""
    ) {
      showFieldError(
        "incident_log_accident_incident_datetime",
        "Please select the date & time of accident/incident!",
      );
      applyError = true;
    } else if (
      new Date(incidentLogData.incident_log_accident_incident_datetime) >
      new Date()
    ) {
      showFieldError(
        "incident_log_accident_incident_datetime",
        "Date & Time of accident/incident cannot be in the future!",
      );
      applyError = true;
    }
    // Date & Time End

    // Accident/Incident being reported Start
    if (
      !incidentLogData.incident_log_accident_incident_report ||
      incidentLogData.incident_log_accident_incident_report.trim() == ""
    ) {
      showFieldError(
        "incident_log_accident_incident_report",
        "Please enter the accident/incident being reported!",
      );
      applyError = true;
    }
    // Accident/Incident being reported End

    // How did the accident/incident happen? Start
    if (
      !incidentLogData.incident_log_accident_incident_description ||
      incidentLogData.incident_log_accident_incident_description.trim() == ""
    ) {
      showFieldError(
        "incident_log_accident_incident_description",
        "Please enter how did the accident/incident happen!",
      );
      applyError = true;
    }
    // How did the accident/incident happen? End

    // Witness Phone Number Start
    if (
      incidentLogData.incident_log_witness_phone_number &&
      !String(incidentLogData.incident_log_witness_phone_number).match(
        /^0\d{10}$/,
      )
    ) {
      showFieldError(
        "incident_log_witness_phone_number",
        "Please enter a valid 11-digit UK telephone number starting with 0!",
      );
      applyError = true;
    }
    // Witness Phone Number End

    // What immediate action was taken? Start
    if (
      !incidentLogData.incident_log_immediate_action_taken ||
      incidentLogData.incident_log_immediate_action_taken.trim() == ""
    ) {
      showFieldError(
        "incident_log_immediate_action_taken",
        "Please enter what immediate action was taken!",
      );
      applyError = true;
    }
    // What immediate action was taken? End

    // Reasons given (by Service User) Start
    if (
      !incidentLogData.incident_log_service_user_reason ||
      incidentLogData.incident_log_service_user_reason.trim() == ""
    ) {
      showFieldError(
        "incident_log_service_user_reason",
        "Please enter the reasons given for cause of accident/incident (by Service User)!",
      );
      applyError = true;
    }
    // Reasons given (by Service User) End

    if (applyError) {
      focusFirstError([
        "incident_log_service_user_name",
        "incident_log_accident_incident_datetime",
        "incident_log_accident_incident_location",
        "incident_log_accident_incident_report",
        "incident_log_accident_incident_description",
        "incident_log_witness_phone_number",
        "incident_log_immediate_action_taken",
        "incident_log_service_user_reason",
      ]);
      return false;
    }

    let allData = incidentLogData;
    allData["users_access_token"] = userDetails.users_access_token;
    allData["incident_log_completed_by_staff_username"] = loggedInUsername;

    // Convert datetime-local value into "Y-m-d H:i:s" format
    if (allData.incident_log_accident_incident_datetime) {
      let incidentDateTime = new Date(
        allData.incident_log_accident_incident_datetime,
      );
      allData["incident_log_accident_incident_datetime"] = incidentDateTime
        .toLocaleString("sv-SE", { hour12: false })
        .replace("T", " ");
    }

    document.getElementById("loader").style.display = "block";
    const response = await dispatch(
      submitDataOnRequest(
        JSON.stringify(allData, null, 2),
        "SaveIncidentLog",
        "",
        [
          getDataOnRequest(
            userDetails.users_access_token,
            "GetIncidentLogs",
            "SET_INCIDENT_LOGS",
          ),
        ],
      ),
    );

    if (response && response.status == "success") {
      successToast("Incident Log saved successfully!");
      setTimeout(() => {
        document.getElementById("loader").style.display = "none";
        redirectUrl("/incident-logs");
      }, 1500);
    } else {
      document.getElementById("loader").style.display = "none";
      errorToast(
        (response && response.msg) || "Something went wrong. Please try again."
      );
    }
  };

  return (
    <React.Fragment>
      <div className="job-bx submit-resume" id="scrollFocusElement">
        <div className="job-bx-title clearfix mb-0">
          <h5 className="font-weight-700 pull-left text-uppercase">
            {isViewMode ? "View Incident Log" : "Accident & Incident Log"}
          </h5>
        </div>
        <form noValidate onSubmit={onSubmit} className="mt-3">
          <div className="row">
            <Input
              label="Service User Name"
              type="text"
              name="incident_log_service_user_name"
              id="incident_log_service_user_name"
              placeholder="Enter Service User Name"
              value={incidentLogData.incident_log_service_user_name || ""}
              readOnly={isViewMode}
              changeHandler={(e) => onChangeInputvalue(e)}
              lg={6}
              req={!isViewMode}
            />

            <Input
              label="Name of staff completing accident/incident form"
              type="text"
              name="incident_log_completed_by_staff_username"
              id="incident_log_completed_by_staff_username"
              value={incidentLogData.incident_log_completed_by_staff_username || loggedInUsername}
              disabled={true}
              changeHandler={(e) => onChangeInputvalue(e)}
              lg={6}
              req={false}
            />

            <Input
              label="Date & Time of accident/incident"
              type="datetime-local"
              name="incident_log_accident_incident_datetime"
              id="incident_log_accident_incident_datetime"
              value={incidentLogData.incident_log_accident_incident_datetime || ""}
              readOnly={isViewMode}
              onKeyDown={(e) => e.preventDefault()}
              max={getNowMax()}
              changeHandler={(e) => onChangeInputvalue(e)}
              lg={4}
              req={!isViewMode}
            />

            <Input
              label="Name of witness(es)"
              type="text"
              name="incident_log_witness_names"
              id="incident_log_witness_names"
              placeholder="Enter Name of witness(es)"
              value={incidentLogData.incident_log_witness_names || ""}
              readOnly={isViewMode}
              changeHandler={(e) => onChangeInputvalue(e)}
              lg={4}
              req={false}
            />

            <Input
              label="Telephone number of witness(es)"
              type="tel"
              name="incident_log_witness_phone_number"
              id="incident_log_witness_phone_number"
              placeholder="Enter UK Telephone number"
              maxLength={11}
              value={incidentLogData.incident_log_witness_phone_number || ""}
              readOnly={isViewMode}
              changeHandler={(e) => onChangeInputvalue(e)}
              lg={4}
              req={false}
            />

            <Textarea
              label="Location of accident/incident"
              name="incident_log_accident_incident_location"
              id="incident_log_accident_incident_location"
              type="text"
              className="form-control"
              placeholder="Enter Location of accident/incident"
              value={incidentLogData.incident_log_accident_incident_location || ""}
              readOnly={isViewMode}
              lg={6}
              rows={5}
              changeHandler={(e) => onChangeInputvalue(e)}
              req={!isViewMode}
            />

            <Textarea
              label="Accident/Incident being reported"
              name="incident_log_accident_incident_report"
              id="incident_log_accident_incident_report"
              type="text"
              className="form-control"
              placeholder="Enter Accident/Incident being reported"
              value={incidentLogData.incident_log_accident_incident_report || ""}
              readOnly={isViewMode}
              lg={6}
              rows={5}
              changeHandler={(e) => onChangeInputvalue(e)}
              req={!isViewMode}
            />

            <Textarea
              label="How did the accident/incident happen?"
              name="incident_log_accident_incident_description"
              id="incident_log_accident_incident_description"
              type="text"
              className="form-control"
              placeholder="Enter How did the accident/incident happen?"
              value={incidentLogData.incident_log_accident_incident_description || ""}
              readOnly={isViewMode}
              lg={6}
              rows={5}
              changeHandler={(e) => onChangeInputvalue(e)}
              req={!isViewMode}
            />

            <Textarea
              label="Details of apparent injuries"
              name="incident_log_apparent_injuries"
              id="incident_log_apparent_injuries"
              type="text"
              className="form-control"
              placeholder="Enter Details of apparent injuries"
              value={incidentLogData.incident_log_apparent_injuries || ""}
              readOnly={isViewMode}
              lg={6}
              rows={5}
              changeHandler={(e) => onChangeInputvalue(e)}
              req={false}
            />

            <Textarea
              label="Reasons given for cause of accident/incident (by Service User)"
              name="incident_log_service_user_reason"
              id="incident_log_service_user_reason"
              type="text"
              className="form-control"
              placeholder="Enter Reasons given by Service User"
              value={incidentLogData.incident_log_service_user_reason || ""}
              readOnly={isViewMode}
              lg={12}
              rows={5}
              changeHandler={(e) => onChangeInputvalue(e)}
              req={!isViewMode}
            />

            <Textarea
              label="What immediate action was taken?"
              name="incident_log_immediate_action_taken"
              id="incident_log_immediate_action_taken"
              type="text"
              className="form-control"
              placeholder="Enter What immediate action was taken?"
              value={incidentLogData.incident_log_immediate_action_taken || ""}
              readOnly={isViewMode}
              lg={6}
              rows={5}
              changeHandler={(e) => onChangeInputvalue(e)}
              req={!isViewMode}
            />

            <Textarea
              label="Reasons given for cause of accident/incident (by Witnesses)"
              name="incident_log_witness_reason"
              id="incident_log_witness_reason"
              type="text"
              className="form-control"
              placeholder="Enter Reasons given by Witnesses"
              value={incidentLogData.incident_log_witness_reason || ""}
              readOnly={isViewMode}
              lg={6}
              rows={5}
              changeHandler={(e) => onChangeInputvalue(e)}
              req={false}
            />

            {isViewMode && (
              <Input
                label="Reported to Staffing Connect management"
                type="text"
                name="incident_log_reported_to_management_datetime"
                id="incident_log_reported_to_management_datetime"
                value={
                  incidentLogData.incident_log_reported_to_management_datetime
                    ? new Date(incidentLogData.incident_log_reported_to_management_datetime).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      }).toUpperCase()
                    : ""
                }
                disabled={true}
                changeHandler={(e) => onChangeInputvalue(e)}
                lg={6}
                req={false}
              />
            )}

            <div className="col-sm-12">
              {!isViewMode && (
                <Button className="site-button m-b30 float-right" type="submit">
                  Save
                </Button>
              )}
              <a
                href="/incident-logs"
                className="site-button text-white yellow m-b30 float-right mr-3"
                type="button"
              >
                Back
              </a>
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.auth.authUserData,
    userProfileData: state.userProfile.userData,
  };
};

export default connect(mapStateToProps)(IncidentLog);
